module.exports = __webpack_public_path__ + "img/BM.7d91827f.svg";